import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  menuItem: {
    padding: "12px 16px",
    color: theme.palette.text.primary,
    textTransform: "none",
    justifyContent: "start",
    alignItems: "start",
    textAlign: "left",
    width: "100%",
    cursor: "pointer",
    display: "flex",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  avatar: {
    marginRight: "8px",
    backgroundColor: theme.palette.grey[100],
  },
  notificationText: {
    whiteSpace: "break-spaces",
    flexGrow: 1,
  },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    flexShrink: 0,
    backgroundColor: theme.palette.error.main,
    marginTop: "16px",
    marginLeft: "18px",
  },
}));

export default useStyles;
